export default function IconParcel({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_83_361)">
                <path
                    d="M29.4819 8.62399L19.4819 3.12399C19.3343 3.04279 19.1685 3.00021 19 3.00021C18.8315 3.00021 18.6658 3.04279 18.5181 3.12399L8.51812 8.62399C8.36133 8.71031 8.23058 8.83713 8.13952 8.99122C8.04846 9.14531 8.00043 9.32101 8.00043 9.49999C8.00043 9.67897 8.04846 9.85467 8.13952 10.0088C8.23058 10.1628 8.36133 10.2897 8.51812 10.376L18 15.5913V26.3086L14.9638 24.6393L14 26.3912L18.5181 28.876C18.6657 28.9573 18.8315 29 19 29C19.1685 29 19.3343 28.9573 19.4819 28.876L29.4819 23.376C29.6388 23.2897 29.7696 23.1629 29.8607 23.0088C29.9519 22.8547 30 22.679 30 22.5V9.49999C30 9.32097 29.9519 9.14524 29.8607 8.99115C29.7696 8.83706 29.6388 8.71026 29.4819 8.62399ZM19 5.14159L26.9248 9.49999L19 13.8584L11.0752 9.49999L19 5.14159ZM28 21.9087L20 26.3087V15.5913L28 11.1913V21.9087Z"
                    fill="currentColor"
                />
                <path d="M2 16L10 16V14H2V16Z" fill="currentColor" />
                <path d="M4 24H12V22H4V24Z" fill="currentColor" />
                <path d="M6 20H14V18H6V20Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_83_361">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
